import { StatusEnums } from "../enums/status-orden-service.enums"

export const Documents = [
  { id: 1, value: "CC", description: 'Cedula de Ciudadanía' },
  { id: 2, value: "CE", description: 'Cedula de Extranjería' },
  { id: 3, value: "PP", description: 'Pasaporte' },
  { id: 4, value: "NIT", description: 'NIT' },
  { id: 5, value: "PTP", description: 'Permiso Temporal de Protección' },
]

export const Roles = [
  { id: 1, value: "ADMIN", description: 'Administrador' },
  { id: 2, value: "MANAGER", description: 'Gerente' },
  { id: 3, value: "TECHNICAL", description: 'Técnico' },
  { id: 4, value: "CLIENT", description: 'Cliente' },
  { id: 5, value: "GUEST", description: 'Invitado' },
]
export const Status = [
  { id: 1, value: StatusEnums.RECIBIDA, description: StatusEnums.RECIBIDA },
  { id: 2, value: StatusEnums.RECIBIDA_TECNICO, description: StatusEnums.RECIBIDA_TECNICO },
  { id: 3, value: StatusEnums.PROGRAMADA, description: StatusEnums.PROGRAMADA },
  { id: 4, value: StatusEnums.EN_TALLER, description: StatusEnums.EN_TALLER },
  { id: 5, value: StatusEnums.CERRADA, description: StatusEnums.CERRADA },
  { id: 6, value: StatusEnums.DEVUELTA, description: StatusEnums.DEVUELTA },
  { id: 7, value: StatusEnums.REGISTRO_TALLER, description: StatusEnums.REGISTRO_TALLER },
  { id: 8, value: StatusEnums.CANCELADA, description: StatusEnums.CANCELADA },
]
